// Used to force recomputation. 
// https://logaretm.com/blog/2019-10-11-forcing-recomputation-of-computed-properties/
export default {
  forceAuthenticationReactivity: 0,
  expiryTimer: null,
  jwt: null,
  refreshTimer: null
}